import { render, staticRenderFns } from "./FinalizeOrderPopup.vue?vue&type=template&id=06587192&scoped=true&"
import script from "./FinalizeOrderPopup.vue?vue&type=script&lang=js&"
export * from "./FinalizeOrderPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06587192",
  null
  
)

export default component.exports